import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const ZoomOut = ({
  width = 21,
  height = 3,
  className,
  color,
  decorative = true,
  ariaLabel = "Zoom out",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 21 3"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
        d="M19.8 1.855H.6V.6h19.2z"
      />
    </svg>
  );
};
